import { defineNuxtPlugin, provideGlobalConfig } from '#imports';

export default defineNuxtPlugin(nuxtApp => { 
  provideGlobalConfig({"zIndex":20000}, nuxtApp.vueApp, true);
})